import React, { useEffect } from "react";
import { ReactComponent as QuizIcon } from "../../assets/images/quiz.svg";
import { ReactComponent as PDFIcon } from "../../assets/images/test.svg";
import { ReactComponent as VideoIcon } from "../../assets/images/video.svg";
import { ReactComponent as GreenTick } from "../../assets/images/greenTick.svg";
import { ReactComponent as TextIcon } from "../../assets/images/textIcon.svg";
import DescriptionIcon from "@material-ui/icons/Description";
import LockIcon from "@material-ui/icons/Lock";
import "./SelfLearning.scss";
import { Box, ButtonBase, useMediaQuery } from '@material-ui/core';
import { selfLearningVideoUrl } from "examsbook-react-sdk/actions/selfLearningVideoUrl";
import { useDispatch, useSelector } from "react-redux";
import { useStyles } from "examsbook-react-sdk/custom-hooks";
import { ColorsConstant } from "../../constants/colorConstant";
import { setDataId, setSectionId } from "examsbook-react-sdk/actions/getSelfLearningAction";
import { useTheme as useMuiTheme } from "@material-ui/core/styles";
import { useTheme } from "../../constants/themeProvider";
import { CircularProgressbar } from "react-circular-progressbar";
import PropTypes from 'prop-types';

function LinearProgressWithLabel({ value = 0, isMobile, primaryColor, primaryFontText }) {
  const overallProgress = Math.round(value);

  return (
    <Box width="100%" display="flex" alignItems="center" justifyContent="center" sx={{ gap: isMobile ? "6px" : '10px' }}>
      {overallProgress <= 99 && (
        <Box width={isMobile ? "18px" : "20px"}>
          <CircularProgressbar value={overallProgress} styles={{ path: { stroke: isMobile ? primaryFontText : primaryColor, strokeWidth: '10px' } }}/>
        </Box>
      )}
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  value: PropTypes.number,
  isMobile: PropTypes.bool,
  primaryColor: PropTypes.string,
  primaryFontText: PropTypes.string,
};

export default function SelfLearningSubmenu(props) {
  const {
    data,
    isCourseExpired,
    selectedSubmenu,
    sectionId,
    sectionIndex,
    index,
    handleUpdateCourseProgress,
    setCurrentSectionIndex,
    setCurrentDataIndex,
    openPdfViewer,
    setSelectedSubmenu,
    setSectionChanged,
    courseId,
    section,
    onPdfOpen,
    pdfOpen,
    onSubmenuClick,
  } = props;
  const subMenuName = props;
  const iconName = data?.refModel;
  const dispatch = useDispatch();
  const classes = useStyles(styles)();
  const theme = useTheme();
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm"));
  useSelector(state => state.selfLearningReducers.sectionId);
  useSelector(state => state.selfLearningReducers.dataId);
  const isExpiredAssignment = isCourseExpired && iconName === "Assignments";

  useEffect(() => {
    if (selectedSubmenu !== null && selectedSubmenu !== undefined) {
      dispatch(setDataId(selectedSubmenu));
    }
  }, [dispatch, selectedSubmenu]);

  useEffect(() => {
    if (sectionId !== null && sectionId !== undefined) {
      dispatch(setSectionId(sectionId));
    }
  }, [sectionId, dispatch]);

  const handleGreenTick = (data) => {
    if (data?.isRead && data?.percent >= 99) {
      return <GreenTick/>;
    }
     else {
      return (
        <Box>
          <LinearProgressWithLabel value={data?.percent} isMobile={isMobile} primaryColor={theme?.primaryColor} primaryFontText={theme?.primaryFontText} />
        </Box>
      );
    }
  };

  const handleOnClick = (id) => {
    setCurrentDataIndex(index);
    setCurrentSectionIndex(sectionIndex);
    setSelectedSubmenu(id);
    dispatch(setSectionId(sectionId));
    dispatch(setDataId(data?._id));
    if (data?.refModel === "RecordedVideo") {
      dispatch(selfLearningVideoUrl(subMenuName));
      setSectionChanged(false);
    } else if (data?.refModel === "TextNotes") {
      dispatch(selfLearningVideoUrl(subMenuName));
      const progressData = {
        sectionId,
        dataId: data?._id,
        percent: 100,
        courseId: courseId || section?.data?.courseId?._id,
        isRead: true
      };
      handleUpdateCourseProgress(progressData);
    } else if (data?.refModel === "PdfNotes") {
      const progressData = {
        sectionId,
        dataId: data?._id,
        percent: 100,
        courseId: courseId || section?.data?.courseId?._id,
        isRead: true
      };
      handleUpdateCourseProgress(progressData);
      onPdfOpen(!pdfOpen);
      openPdfViewer(data?.contentData?.featured);
    }
    if (onSubmenuClick) {
      onSubmenuClick(data);
    }
  };

  return (
      <ButtonBase
        id={index}
        className="outerBox2 submenu isHover"
        style={{
          backgroundColor:
            selectedSubmenu === data?._id
              ? ColorsConstant.backgroundHighlight
              : "transparent",
          opacity: isExpiredAssignment ? 0.5 : 1,
          cursor: isExpiredAssignment ? 'not-allowed' : 'pointer',
        }}
        onClick={() => handleOnClick(data?._id)}
        disabled={isExpiredAssignment}
      >
        <div className="innerBox">
          <div className="submenu-content">
            <div className="submenu-image">
              {iconName === "Quiz" && <QuizIcon />}
              {iconName === "RecordedVideo" && <VideoIcon />}
              {iconName === "PdfNotes" && <PDFIcon />}
              {iconName === "TextNotes" && <TextIcon />}
              {iconName === "Questions" && <QuizIcon />}
              {iconName === "Assignments" && <DescriptionIcon style={{ color: 'black', opacity: 0.54 }} />}
            </div>
            <p className={classes.genustext}>{data?.name}</p>
          </div>
          {isExpiredAssignment ? (
            <Box display="flex" alignItems="center" style={{ gap: '4px', color: '#9e9e9e', fontSize: '12px' }}>
              <LockIcon style={{ fontSize: '16px' }} />
            </Box>
          ) : (
            <Box display="flex">{handleGreenTick(data)}</Box>
          )}
        </div>
      </ButtonBase>
  );
}

SelfLearningSubmenu.propTypes = {
  data: PropTypes.shape({
    _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    refModel: PropTypes.string,
    name: PropTypes.string,
    isRead: PropTypes.bool,
    percent: PropTypes.number,
    contentData: PropTypes.shape({
      featured: PropTypes.string,
    }),
  }),
  isCourseExpired: PropTypes.bool,
  selectedSubmenu: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sectionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sectionIndex: PropTypes.number,
  index: PropTypes.number,
  handleUpdateCourseProgress: PropTypes.func,
  setCurrentSectionIndex: PropTypes.func,
  setCurrentDataIndex: PropTypes.func,
  openPdfViewer: PropTypes.func,
  setSelectedSubmenu: PropTypes.func,
  setSectionChanged: PropTypes.func,
  courseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  section: PropTypes.shape({
    data: PropTypes.shape({
      courseId: PropTypes.shape({
        _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
    }),
  }),
  onPdfOpen: PropTypes.func,
  pdfOpen: PropTypes.bool,
  onSubmenuClick: PropTypes.func,
};

const styles = {
  genustext: {
    display: 'flex',
    alignItems: 'center',
    margin: '10px 0px',
    gap: '10px',
    width: '-webkit-fill-available',
    fontSize: '14px',
    color: ColorsConstant.descriptionColor,
    fontWeight: 400,
    "@media (max-width: 767px)": {
      width: "auto",
    },
  },
};
